import { RCCServicesApi } from "react-common-components";
import formatDate from "src/utils/formatDate";
import IFiltersActionsPanel, { IGroupersActionsSelect, IListActions } from "./interface";

export interface IGroupersActions{
    grouperId: number | string; 
    grouperId2?: number | null; 
    grouperId3?: number | null; 
    grouperId4?: number | null;
}

const executeQueryListOfActions = async (groupersSelect: IGroupersActionsSelect, groupers: IGroupersActions, filters: IFiltersActionsPanel = {} as IFiltersActionsPanel) => {
	const {data} = await RCCServicesApi.getRequest({
		method: "Actions/List",
		urlParameters: {
			...groupersSelect,
			id: groupers.grouperId === 0 ? "" : groupers.grouperId,
			id2: groupers.grouperId2 || "",
			id3: groupers. grouperId3 || "",
			id4: groupers.grouperId4 || "",
			f: filters.f || "",
			responsible: filters.responsible || "",
			authority: filters.authority || "",
			consulted: filters.consulted || "",
			informed: filters.informed || "",
			sector: filters.sector || "",
			situation: filters.situation || "",
			startDate: filters.startDate ? formatDate(filters.startDate) : "",
			endDate: filters.endDate ? formatDate(filters.endDate) : "",
			tags: filters.tags || "",
			map: filters.map || "",
			perspective: filters.perspective || "",
			objective: filters.objective || "",
			indicator: filters.indicator || "",
			filterOrigin: filters.filterOrigin || "",
			startPerc: filters.percConclusion && Array.isArray(filters.percConclusion) && filters.percConclusion.length > 0 ? filters.percConclusion[0] : 0,
			endPerc: filters.percConclusion && Array.isArray(filters.percConclusion) && filters.percConclusion.length > 0 ? filters.percConclusion[1] : 100,
			actionId: filters.actionId || "",
			validateRaci: filters.notValidateRaci ? !filters.notValidateRaci : true
		}
	});
	const listActions = data as IListActions[];

	return listActions;
};

export default executeQueryListOfActions;
